import {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from 'vue-router';
import { useUserStore } from './user-store';
import useUserRepository from './modules/use-user-repository';

const userRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    component: () =>
      import('@/app/shared/components/layouts/default-layout-component.vue'),
    children: [
      {
        path: 'login',
        component: () =>
          import('@/app/user/components/auth/login-component.vue'),
        name: 'app.login',
      },
      {
        path: 'forgot-password',
        component: () =>
          import('@/app/user/components/auth/forgot-password-component.vue'),
        name: 'app.forgot_password',
      },
    ],
  },
  {
    path: '',
    component: () =>
      import('@/app/shared/components/layouts/app-layout-component.vue'),
    children: [
      {
        path: 'user/:userId',
        component: () =>
          import('@/app/user/components/profile/user-index-component.vue'),
        children: [
          {
            path: 'primary-info',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-primary-info-component.vue'
              ),
            name: 'app.user.primary-info',
          },
          {
            path: 'working-times',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-working-time-component.vue'
              ),
            name: 'app.user.working-times',
          },
          {
            path: 'secondary-info',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-secondary-info-component.vue'
              ),
            name: 'app.user.secondary-info',
          },
          {
            path: 'permissions',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-permissions-component.vue'
              ),
            name: 'app.user.permissions',
          },
          {
            path: 'holidays',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-holidays-component.vue'
              ),
            name: 'app.user.holidays',
          },
          {
            path: 'attendance-sheet',
            component: () =>
                import(
                    '@/app/user/components/profile/pages/attendance-sheet-component.vue'
                    ),
            name: 'app.user.attendance_sheet',
          },
          {
            path: 'timer-history',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-timer-history-component.vue'
              ),
            name: 'app.user.timer_history',
          },
          {
            path: 'task-calendar',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-task-calendar-component.vue'
              ),
            name: 'app.user.task_calendar',
          },
          {
            path: 'hierarchy',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-hierarchy-component.vue'
              ),
            name: 'app.user.hierarchy',
          },
          {
            path: 'app-service',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-app-service-component.vue'
              ),
            name: 'app.user.app-service',
          },
          {
            path: 'notifications',
            component: () =>
              import(
                '@/app/user/components/profile/pages/user-notifications-component.vue'
              ),
            name: 'app.user.notifications',
          },
          {
            path: 'assets',
            component: () =>
                import(
                    '@/app/user/components/profile/pages/user-asset-component.vue'
                    ),
            name: 'app.user.assets',
          },
        ],
      },
    ],
  },
  {
    path: 'reset-password/:token',
    component: () =>
      import('@/app/user/components/auth/reset-password-component.vue'),
    name: 'app.reset_password',
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ): Promise<void> => {
      next();
      const userStore = useUserStore();

      const { checkResetPasswordToken } = useUserRepository();
      const isTokenValid = await checkResetPasswordToken(
        to.params.token as string
      );
      userStore.setResetPasswordTokenValid(isTokenValid);
      if (userStore.resetPasswordTokenValid) {
        next();
      } else {
        next({ name: 'app.login' });
      }
    },
  },
];

export default userRoutes;
